import { Outlet } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import * as Sentry from '@sentry/react';
import { Header } from './Header';
import { Footer } from './Footer';
import { ToastContainer } from '@shared/components/ui/toast-notification';
import { ErrorFallback } from '@shared/components/ui/ErrorFallback';

export function RootLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Header />
      <main className="flex-1 pt-16">
        <Sentry.ErrorBoundary
          fallback={ErrorFallback}
          showDialog={false}
        >
          <Outlet />
        </Sentry.ErrorBoundary>
      </main>
      <Footer />
      <ToastContainer />
      <Analytics />
    </div>
  );
}